(() => {
  const normalize = (s) =>
    (s || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  function sortCheckedToTop(list) {
    const items = Array.from(list.querySelectorAll("[data-facet-local-item]"));
    if (!items.length) return;

    const checked = [];
    const unchecked = [];

    items.forEach((li) => {
      const cb = li.querySelector('input[type="checkbox"]');
      (cb && cb.checked ? checked : unchecked).push(li);
    });

    if (!checked.length) return;

    checked.forEach((li) => list.appendChild(li));
    unchecked.forEach((li) => list.appendChild(li));
  }

  class FacetLocalSearch extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector("[data-facet-local-search]");
      if (!input) return;

      const scope = input.getAttribute("data-facet-local-search-scope") || "";

      const list = this.querySelector(`[data-facet-local-list="${CSS.escape(scope)}"]`);
      if (!list) return;

      const items = Array.from(list.querySelectorAll("[data-facet-local-item]"));
      if (!items.length) return;

      if (input.dataset.localSearchBound === "1") return;
      input.dataset.localSearchBound = "1";

      const wasHidden = new WeakMap();
      items.forEach((li) => wasHidden.set(li, li.classList.contains("js-hidden")));

      const filterRoot =
        this.closest(".filter__content") ||
        this.closest(".disclosure__content") ||
        this.closest(".filter") ||
        this;

      const showMoreBtn = filterRoot.querySelector(".js-show-more");

      const apply = () => {
        const q = normalize(input.value);

        sortCheckedToTop(list);

        if (q) {
          items.forEach((li) => li.classList.remove("js-hidden"));
          if (showMoreBtn) showMoreBtn.setAttribute("hidden", "hidden");
        } else {
          items.forEach((li) => {
            if (wasHidden.get(li)) li.classList.add("js-hidden");
            else li.classList.remove("js-hidden");
          });
          if (showMoreBtn) showMoreBtn.removeAttribute("hidden");
        }

        items.forEach((li) => {
          const text = normalize(li.textContent);
          li.style.display = !q || text.includes(q) ? "" : "none";
        });
      };

      input.addEventListener("input", apply);

      list.addEventListener("change", (e) => {
        if (e.target && e.target.matches('input[type="checkbox"]')) {
          apply();
        }
      });

      apply();
    }
  }

  if (!customElements.get("facet-local-search")) {
    customElements.define("facet-local-search", FacetLocalSearch);
  }
})();
